export const WHITE = '#FFFFFF'
export const BLACK = '#292929'
export const GREY = '#585858'
export const GREY_BLUE = '#41535D'
export const GREY_LIGHT = '#E3E9EC'

export const RED = '#E64725'
export const BLUE = '#00B9F1'
export const BLUE_DARK = '#0092C8'
export const BLUE_LIGHT = '#6DD0F6'
export const YELLOW = '#FAC706'

export const TABLE_BLUE = '#1069AB'

export const PRIMARY = '#3F51B5'
export const ACCENT = '#FF4081'
export const LIGHT_GREY = 'rgba(0, 0, 0, 0.12)'
export const MEDIUM_GREY = 'rgba(158,158,158, 0.20)'
export const DARK_GREY = 'rgba(0,0,0, 0.26)'



// WEBPACK FOOTER //
// ./src/colors.js